import { isNotEmpty, useForm } from '@mantine/form'
import { useGetRolesQuery } from '@v2/domains/role/models/role.api'

import { IUserMembership } from '../membership.types'
import { useMembershipMutations } from './useMembershipMutations.hook'

const useUpdateMembership = (membershipId: string) => {
  const { updateMembership, isLoadingUpdate } = useMembershipMutations()
  const { data: roles } = useGetRolesQuery()

  const form = useForm<Pick<IUserMembership, 'id' | 'role' | 'status'>>({
    mode: 'uncontrolled',
    initialValues: {
      id: membershipId,
      role: '',
      status: 'active',
    },
    validateInputOnBlur: true,
    validate: {
      role: isNotEmpty('Role is required!'),
    },
  })

  const onSubmit = () => {
    form.onSubmit(async (values) => {
      await updateMembership(values)
    })()
  }

  return {
    form,
    onSubmit,
    isLoadingUpdate,
    membershipRoleList:
      roles?.records?.map((role) => ({ value: role.id, label: role.name })) ??
      [],
  }
}

export default useUpdateMembership
